// extracted by mini-css-extract-plugin
export var addToCartButton = "_q2-b";
export var arrowButtonContainer = "_q2-9";
export var arrowButtonIcon = "_q2-a";
export var carouselArrowButton = "_q2-6";
export var carouselElementContainer = "_q2-1";
export var galleryThumbnail = "_q2-d";
export var galleryThumbnailImage = "_q2-e";
export var left = "_q2-7";
export var productDisplayCarouselContainer = "_q2-0";
export var productTileContainer = "_q2-2";
export var productTileImage = "_q2-4";
export var productTileImageContainer = "_q2-3";
export var productTileTitle = "_q2-5";
export var right = "_q2-8";
export var sliderOverflow = "_q2-c";